import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/apiClient";
import AuthShell from "@/components/layout/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, a reset link was sent");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset password"
      subtitle="We'll email you a reset link."
      footer={<Link to="/login" className="text-zinc-200 underline underline-offset-4" data-testid="link-login">Back to sign in</Link>}
    >
      {sent ? (
        <div className="rounded-md border border-zinc-800 bg-zinc-900/40 p-4 text-sm text-zinc-300" data-testid="forgot-sent">
          Check your inbox. In development, the reset link is printed to the backend console.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-zinc-300">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email" className="bg-zinc-950 border-zinc-800" required />
          </div>
          <Button type="submit" disabled={loading} data-testid="forgot-submit"
            className="w-full bg-zinc-50 text-zinc-900 hover:bg-zinc-200">
            {loading ? "Sending…" : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
